import React, { useState } from "react";
import { SearchDropDownWithBase } from "../../../../components";
import queryString from "query-string";
import values from "../../../../values";
import Context from "../../../../context";
import { IOnSearchUser } from "../../../../types/common.interface";
import utils from "../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

const SearchAgent = () => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // ============================ Value Validations =========================
  const { requestAbsent, setRequestAbsent } = React.useContext(
    Context.AbsentScreen
  );
  const [defaultSearch, setDefaultSearch] = useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );
  const baseSearch =
    userType === "ADMIN"
      ? values.dropdownBaseSearch.COMPANY_BASE_SEARCH
      : values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE;

  // =============================== Navigation =============================

  function onSearch(event: IOnSearchUser) {
    setRequestAbsent({
      ...requestAbsent,
      search: {
        base: event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  const { t } = useTranslation();

  // ============================== JSX Contents ============================
  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: IOnSearchUser) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch.map((item) => {
        return { ...item, title: t(item?.title) };
      })}
    />
  );
};

export default SearchAgent;
